import {Injectable} from '@angular/core';
import {RestClientService} from 'shared-lib';
import {Observable} from 'rxjs';
import {GhostMerchantBounty} from './models/ghost-merchant-bounty';
import {HttpParams} from '@angular/common/http';
import {GhostMerchantBountyProgress} from './models/ghost-merchant-bounty-progress';

@Injectable({
  providedIn: 'root'
})
export class GhostMerchantBountyService {

  constructor(private restClient: RestClientService) {
  }

  public getUserBounties(): Observable<GhostMerchantBounty[]> {
    return this.restClient.get<GhostMerchantBounty[]>(`/merchants/bounty`);
  }

  public getGhostMerchantBountyProgress(ghostMerchantBountyId: string): Observable<GhostMerchantBountyProgress> {
    const httpParam = new HttpParams().set('ghostMerchantBountyId', ghostMerchantBountyId);
    return this.restClient.put<GhostMerchantBountyProgress>(`/merchants/bounty-progress`, {}, {params: httpParam});
  }
}
